import { Settings } from "./SettingsContext";

const settings: Settings = {
  brands: ["Audi", "BMW", "Land Rover"],
  importCostsFixed: 740,
  importPercentageStaffel: [
    { from: 0, to: 10000, percentage: 12.5 },
    { from: 10001, to: 20000, percentage: 10 },
    { from: 20001, to: 30000, percentage: 9 },
    { from: 30001, to: 40000, percentage: 7.5 },
    { from: 40001, to: 60000, percentage: 6 },
    { from: 60001, to: 1000000, percentage: 5 },
  ],
  bpmRows: {
    2021: {
      bpmGasoline: [
        {
          from: 0,
          pricePerGram: 372,
        },
        {
          from: 86,
          pricePerGram: 1,
        },
        {
          from: 111,
          pricePerGram: 60,
        },
        {
          from: 155,
          pricePerGram: 132,
        },
        {
          from: 172,
          pricePerGram: 216,
        },
        {
          from: 1000,
          pricePerGram: 432,
        },
      ],
      bpmDiesel: [
        {
          from: 0,
          pricePerGram: 372,
        },
        {
          from: 86,
          pricePerGram: 1,
        },
        {
          from: 111,
          pricePerGram: 60,
        },
        {
          from: 155,
          pricePerGram: 132,
        },
        {
          from: 172,
          pricePerGram: 216,
        },
        {
          from: 1000,
          pricePerGram: 432,
        },
      ],
      bpmHybrid: [
        {
          from: 34,
          pricePerGram: 24,
        },
        {
          from: 60,
          pricePerGram: 84,
        },
        {
          from: 1000,
          pricePerGram: 202,
        },
      ],
    },
    2020: {
      bpmGasoline: [
        {
          from: 0,
          pricePerGram: 366,
        },
        {
          from: 90,
          pricePerGram: 1,
        },
        {
          from: 116,
          pricePerGram: 57,
        },
        {
          from: 162,
          pricePerGram: 124,
        },
        {
          from: 180,
          pricePerGram: 204,
        },
        {
          from: 1000,
          pricePerGram: 408,
        },
      ],
      bpmDiesel: [
        {
          from: 0,
          pricePerGram: 366,
        },
        {
          from: 90,
          pricePerGram: 1,
        },
        {
          from: 116,
          pricePerGram: 57,
        },
        {
          from: 162,
          pricePerGram: 124,
        },
        {
          from: 180,
          pricePerGram: 204,
        },
        {
          from: 1000,
          pricePerGram: 408,
        },
      ],
      bpmHybrid: [
        {
          from: 34,
          pricePerGram: 24,
        },
        {
          from: 60,
          pricePerGram: 83,
        },
        {
          from: 1000,
          pricePerGram: 199,
        },
      ],
    },
    2019: {
      bpmGasoline: [
        {
          from: 0,
          pricePerGram: 360,
        },
        {
          from: 71,
          pricePerGram: 2,
        },
        {
          from: 95,
          pricePerGram: 60,
        },
        {
          from: 139,
          pricePerGram: 131,
        },
        {
          from: 156,
          pricePerGram: 215,
        },
        {
          from: 1000,
          pricePerGram: 429,
        },
      ],
      bpmDiesel: [
        {
          from: 0,
          pricePerGram: 360,
        },
        {
          from: 71,
          pricePerGram: 2,
        },
        {
          from: 95,
          pricePerGram: 58,
        },
        {
          from: 139,
          pricePerGram: 129,
        },
        {
          from: 156,
          pricePerGram: 213,
        },
        {
          from: 1000,
          pricePerGram: 426,
        },
      ],
      bpmHybrid: [
        {
          from: 30,
          pricePerGram: 27,
        },
        {
          from: 50,
          pricePerGram: 113,
        },
        {
          from: 1000,
          pricePerGram: 271,
        },
      ],
    },
    2018: {
      bpmGasoline: [
        {
          from: 0,
          pricePerGram: 353,
        },
        {
          from: 73,
          pricePerGram: 2,
        },
        {
          from: 98,
          pricePerGram: 63,
        },
        {
          from: 144,
          pricePerGram: 139,
        },
        {
          from: 162,
          pricePerGram: 229,
        },
        {
          from: 1000,
          pricePerGram: 458,
        },
      ],
      bpmDiesel: [
        {
          from: 0,
          pricePerGram: 356,
        },
        {
          from: 73,
          pricePerGram: 2,
        },
        {
          from: 98,
          pricePerGram: 63,
        },
        {
          from: 144,
          pricePerGram: 139,
        },
        {
          from: 162,
          pricePerGram: 229,
        },
        {
          from: 1000,
          pricePerGram: 458,
        },
      ],
      bpmHybrid: [
        {
          from: 30,
          pricePerGram: 19,
        },
        {
          from: 50,
          pricePerGram: 87,
        },
        {
          from: 1000,
          pricePerGram: 289,
        },
      ],
    },
    2017: {
      bpmGasoline: [
        {
          from: 0,
          pricePerGram: 353,
        },
        {
          from: 76,
          pricePerGram: 2,
        },
        {
          from: 102,
          pricePerGram: 66,
        },
        {
          from: 150,
          pricePerGram: 145,
        },
        {
          from: 168,
          pricePerGram: 238,
        },
        {
          from: 1000,
          pricePerGram: 475,
        },
      ],
      bpmDiesel: [
        {
          from: 0,
          pricePerGram: 353,
        },
        {
          from: 76,
          pricePerGram: 2,
        },
        {
          from: 102,
          pricePerGram: 66,
        },
        {
          from: 150,
          pricePerGram: 145,
        },
        {
          from: 168,
          pricePerGram: 238,
        },
        {
          from: 1000,
          pricePerGram: 475,
        },
      ],
      bpmHybrid: [
        {
          from: 30,
          pricePerGram: 19,
        },
        {
          from: 50,
          pricePerGram: 87,
        },
        {
          from: 1000,
          pricePerGram: 289,
        },
      ],
    },
  },
  lumpPercentageTable: [
    {
      minAge: 0,
      maxAge: 1,
      percentage: 0,
      monthlyAdditionPercentage: 8,
    },
    {
      minAge: 1,
      maxAge: 3,
      percentage: 8,
      monthlyAdditionPercentage: 3,
    },
    {
      minAge: 3,
      maxAge: 5,
      percentage: 14,
      monthlyAdditionPercentage: 2.5,
    },
    {
      minAge: 5,
      maxAge: 9,
      percentage: 19,
      monthlyAdditionPercentage: 2.25,
    },
    {
      minAge: 9,
      maxAge: 18,
      percentage: 28,
      monthlyAdditionPercentage: 1.444,
    },
    {
      minAge: 18,
      maxAge: 30,
      percentage: 41,
      monthlyAdditionPercentage: 0.917,
    },
    {
      minAge: 30,
      maxAge: 42,
      percentage: 52,
      monthlyAdditionPercentage: 0.833,
    },
    {
      minAge: 42,
      maxAge: 54,
      percentage: 62,
      monthlyAdditionPercentage: 0.75,
    },
    {
      minAge: 54,
      maxAge: 66,
      percentage: 71,
      monthlyAdditionPercentage: 0.416,
    },
    {
      minAge: 66,
      maxAge: 78,
      percentage: 76,
      monthlyAdditionPercentage: 0.416,
    },
    {
      minAge: 78,
      maxAge: 90,
      percentage: 81,
      monthlyAdditionPercentage: 0.333,
    },
    {
      minAge: 90,
      maxAge: 102,
      percentage: 85,
      monthlyAdditionPercentage: 0.333,
    },
    {
      minAge: 102,
      maxAge: 114,
      percentage: 89,
      monthlyAdditionPercentage: 0.25,
    },
    {
      minAge: 114,
      maxAge: 126,
      percentage: 92,
      monthlyAdditionPercentage: 0.083,
    },
  ],
  dieselPremium: {
    2021: {
      dieselPremiumFrom: 80,
      dieselPremiumPricePerGram: 78.82,
    },
    2020: {
      dieselPremiumFrom: 80,
      dieselPremiumPricePerGram: 78.82,
    },
    2019: {
      dieselPremiumFrom: 61,
      dieselPremiumPricePerGram: 88.43,
    },
    2018: {
      dieselPremiumFrom: 63,
      dieselPremiumPricePerGram: 87.38,
    },
    2017: {
      dieselPremiumFrom: 65,
      dieselPremiumPricePerGram: 86.69,
    },
  },
};

export default settings;
